import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import {DialogAction} from '../../../contracts/dialog.interface';

@Component({
  selector: 'kc-footer',
  standalone: true,
  imports: [ButtonModule],
  template:  `
        <div class="flex w-full justify-end mt-4">
            <p-button type="button" label="Annulla" size="small" icon="pi pi-times-circle" severity="secondary" class="mr-2" (click)="closeDialog({ action: DialogAction.CLOSE})" />
            <p-button type="button" label="Conferma" size="small" icon="pi pi-check-circle" (click)="closeDialog({ action: DialogAction.OK })" />
        </div> `
})
export class Footer {
  constructor(public ref: DynamicDialogRef) {}

  closeDialog(data: any) {
    this.ref.close(data);
  }

  protected readonly DialogAction = DialogAction;
}
